import { defineComponent as _defineComponent } from 'vue'
import { useLazyAsyncData, useNuxt2Meta, useRoute } from '#app'
import { computed } from 'vue'
import { MetaInfo } from 'vue-meta'
import { getFaqMachine } from '../inversify.config'
import { FaqStandalone } from '../schemas'
import SCHEMA_ORGANIZATION from '../../../json/schemaOrganization.json'


export default /*#__PURE__*/_defineComponent({
  __name: 'FaqStandaloneMain',
  props: {
    slug: null,
    url: null
  },
  setup(__props: any) {

const props = __props as { slug: string; url: string };


const route = useRoute()
const lang = route.params.lang || 'en-gb'
const { data: faq } = useLazyAsyncData(
  `faq-standalone-${props.slug}-${lang}`,
  getFaq,
)

function getFaq() {
  const faqMachine = getFaqMachine(route.params.lang || 'en-gb')
  return new Promise<FaqStandalone | null>((resolve) => {
    faqMachine
      .onTransition((state) => {
        if (
          (state.changed && state.context.standalone) ||
          state.matches('error')
        ) {
          resolve(state.context.standalone || null)
        }
      })
      .start()
      .send('FETCH_STANDALONE', { slug: props.slug })
  })
}

const headData = computed<MetaInfo>(() => {
  if (faq.value === null) {
    return {}
  }
  return {
    title: `${faq.value.question} | Pitchup.com`,
    meta: [
      {
        hid: 'description',
        name: 'description',
        property: 'og:description',
        content: faq.value.description,
      },
    ],
    script: [
      {
        type: 'application/ld+json',
        body: true,
        json: {
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: {
            '@type': 'Question',
            name: faq.value.question,
            answerCount: 1,
            author: {
              '@type': 'Organization',
              name: 'Pitchup.com',
            },
            acceptedAnswer: {
              '@type': 'Answer',
              text: faq.value.answer,
              url: props.url,
              author: {
                '@type': 'Organization',
                name: 'Pitchup.com',
              },
            },
          },
        },
      },
      {
        type: 'application/ld+json',
        body: true,
        json: SCHEMA_ORGANIZATION,
      },
    ],
  }
})

useNuxt2Meta(headData)

return { __sfc: true,props, route, lang, faq, getFaq, headData }
}

})